
namespace Gamification.Gamification {
    export class UtentiProdottiEsperienzeColumns {
        static columnsKey = 'Gamification.UtentiProdottiEsperienze';
    }
}